import cn from 'classnames';
import React from 'react';
import { InstanceProps, create } from 'react-modal-promise';
import { useTranslation } from 'next-i18next';
import { Icon } from 'components';
import { ButtonV3 } from 'components/ComponentV2';
import Modal from 'components/Modal';

import styles from './GetHuzzleVerifiedModal.module.scss';

const ModalInstance: React.FC<
  InstanceProps<{ title: string; link: string } | null>
> = ({ isOpen, onReject, onResolve }) => {
  const [t] = useTranslation('candidate-dashboard');

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onReject}
      contentClassName={cn(styles.container, {})}
      className={styles.modal}
    >
      <div className={styles.header}>
        <div className={styles.headerWrapper}>
          <p className={styles.title}>
            {t('sidebar-left.get-huzzle-verified')}
          </p>
        </div>
      </div>
      <div className={styles.modalContent}>
        <Icon iconName="icon_medal" className={styles.icon} />
        <p
          dangerouslySetInnerHTML={{
            __html: t('sidebar-left.huzzle-verified-modal-text'),
          }}
          className={styles.modalText}
        />
      </div>
      <div className={styles.footer}>
        <ButtonV3
          color="primary"
          size="large"
          className={styles.button}
          onClick={() => onResolve()}
          isFullWidth
        >
          {t('sidebar-left.got-it')}
        </ButtonV3>
      </div>
    </Modal>
  );
};

export const GetHuzzleVerifiedModal = create(ModalInstance);
